import React from "react";
import { useTranslation } from "react-i18next";
import { FiInfo, FiCpu, FiHash, FiGrid, FiActivity } from "react-icons/fi";

const InfoWidget = ({ zone }) => {
  const { t } = useTranslation();
  
  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("اطلاعات ویجت")}</h2>

      {/* Widget Info Card */}
      <div className="schedule-command-info" style={{ marginBottom: "24px" }}>
        <div className="schedule-command-icon">
          <FiInfo size={24} />
        </div>
        <div>
          <p className="schedule-command-label">{zone.property[1] || t("ویجت")}</p>
          <p className="schedule-zone-name">{zone.genesis || t("دستگاه")}</p>
        </div>
      </div>

      {/* Information List */}
      <div className="device-details-grid">
        <div className="device-info-item">
          <div className="device-info-label">
            <FiCpu size={16} />
            <span>{t("نام دستگاه")}</span>
          </div>
          <div className="device-info-value">
            {zone.genesis || "---"}
          </div>
        </div>

        <div className="device-info-item">
          <div className="device-info-label">
            <FiGrid size={16} />
            <span>{t("دسته بندی ویجت")}</span>
          </div>
          <div className="device-info-value">
            {zone.property[1] || "---"}
          </div>
        </div>

        <div className="device-info-item">
          <div className="device-info-label">
            <FiHash size={16} />
            <span>{t("سریال دستگاه ویجت")}</span>
          </div>
          <div className="device-info-value device-serial-value">
            {zone.serial || "---"}
          </div>
        </div>

        <div className="device-info-item">
          <div className="device-info-label">
            <FiActivity size={16} />
            <span>{t("شماره ویجت")}</span>
          </div>
          <div className="device-info-value">
            {zone.index + 1 || "---"}
          </div>
        </div>
      </div>

      {/* History Button */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          style={{ 
            background: "transparent", 
            border: "2px solid #f56565",
            color: "#f56565"
          }}
        >
          <FiActivity size={18} />
          <span>{t("مشاهده تاریخچه")}</span>
        </button>
      </div>
    </div>
  );
};

export { InfoWidget };